import { useEffect } from 'react'
import './Life.css'
import MediaSlideshow from './MediaSlideshow'

const items = [
  { type: 'image', src: 'alan-hockey.jpg' },
  { type: 'image', src: 'boluclac.png' },
  { type: 'image', src: 'alan-piano.jpg' },
  { type: 'video', src: 'IMG_4111.mp4' },
  { type: 'image', src: 'scallops.png' },
  { type: 'image', src: 'oakland.jpeg' },
  { type: 'video', src: 'ducks.mp4' },
  { type: 'image', src: 'steak.png' },
]

function Life() {
  useEffect(() => {
    items.forEach((item) => {
      if (item.type === 'image') {
        const img = new Image()
        img.src = item.src
      } else if (item.type === 'video') {
        const video = document.createElement('video')
        video.preload = 'metadata'
        video.src = item.src
      }
    })
  }, [])
  return (
    <div className="life-container">
      <div className="slideshow-wrapper">
        <MediaSlideshow media={items} />
      </div>

      <div className="text-content">
        <div className="life-intro">
          When I'm not coding, I enjoy cooking, brushing up on roller hockey,
          playing piano, and exploring design. I am no chef or athlete (still
          figuring out how to do my backwards crossovers), but the learning
          process is a big part of what makes these hobbies so enjoyable.
          <br />
          <br />
          I'm also a huge sports junkie who loves looking into stats, not just
          for the numbers, but for the thrill of making predictions and having
          those moments of being right. Whether it's the NHL, NBA, MLB, or NFL,
          I enjoy looking into the analytics and occasionally reminding people
          that I did call that breakout season or upset win before it happened.
        </div>
        <h4>Fun Facts</h4>
        <span className="current-obsession">
          <strong>Current Obsession</strong>: Sports Analytics
        </span>
        <ul className="fun-facts-list">
          {[
            ['Role Models', 'Kobe, Steve Jobs, and my mom'],
            ['Favorite Food', 'Salmon Nigiri'],
            ['Favorite Song', 'Bailar (ft. Elvis Crespo) - Deorro'],
            ['Favorite Movie', 'Nacho Libre'],
            ['Favorite TV Show', 'Atlanta'],
            [
              'Go-to Weekend Activity',
              'Watch live sports, hitting the gym, or cooking new recipes',
            ],
            [
              "Arenas/Stadiums I've Been To",
              'SAP Center, Honda Center, Crypto.com Arena, Intuit Dome, Angel Stadium, Dodger Stadium, Petco Park, Oracle Park, Oakland Coliseum',
            ],
          ].map(([label, value]) => (
            <li key={label}>
              <strong>{label}</strong>: {value}
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default Life
